import { LayoutContextProps, LayoutVariant } from 'providers/LayoutProvider'
import { ContentMaxWidth } from './theme'

const sidebarWidth = 220
const headerHeight = 64

const layoutCore: {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  [keys in LayoutVariant]: {
    id: string
    sidePadding: number
    maxWidthSize: keyof ContentMaxWidth
  } & Pick<LayoutContextProps, 'sidebar' | 'header'>
} = {
  full: {
    id: 'full',
    sidePadding: 12,
    maxWidthSize: 'xxl'
  },
  sidebarFocused: {
    id: 'sidebarFocused',
    sidePadding: 12,
    maxWidthSize: 'xl',
    sidebar: {
      isIncluded: true
    },
    header: {
      isIncluded: true
    }
  },
  sidebarFull: {
    id: 'sidebarFull',
    sidePadding: 7,
    maxWidthSize: 'xxl',
    sidebar: {
      isIncluded: true
    },
    header: {
      isIncluded: true
    }
  },
  calendar: { id: 'calendar', sidePadding: 5, maxWidthSize: 'xxl' },
  styleGuide: {
    id: 'styleGuide',
    sidePadding: 12,
    maxWidthSize: 'xxl',
    sidebar: {
      isIncluded: true
    }
  }
}

const layout = { ...layoutCore, sidebarWidth, headerHeight }
export default layout
